import { LoginButton } from '@appcharge/shared-ui';

import { EFacebookButtonVariant } from '../../components/Theme/LoginTheme/types';

interface IFacebookLoginProps {
  translations: Record<string, string>;
  variant?: EFacebookButtonVariant;
}

export const FacebookLogin: React.FC<IFacebookLoginProps> = ({
  translations,
  variant = EFacebookButtonVariant.DEFAULT
}) => {
  return (
    <LoginButton
      variant={variant === EFacebookButtonVariant.OUTLINED ? 'outlined' : 'facebook'}
      callback={() => {}}
      text={translations?.signInWithFacebook || 'Sign in with Facebook'}
    >
      <img
        src="https://media.appcharge.com/defaults/facebook_icon_white.svg"
        alt="facebook icon"
      />
    </LoginButton>
  );
};
